import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'app/models/company.model';
import { ContainerEnum } from 'app/models/container.enum';
import { Container } from 'app/models/container.model';
import { Device } from 'app/models/device.model';
import { User } from 'app/models/user.model';
import { CompanyService } from 'app/services/company.service';
import { CoordinatesFromAddressService } from 'app/services/coordinates-from-address.service';
import { DeviceService } from 'app/services/device.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from "../../base-form.component";
import { ContainerDeviceListComponent } from '../../container/container-device-list/container-device-list.component';


@Component({
    selector: 'app-map-container-form',
    templateUrl: './map-container-form.component.html',
    styleUrls: ['./map-container-form.component.scss']
})
export class MapContainerFormComponent extends BaseFormComponent implements OnInit {

    public companyId: number
    public _changeDevice: string
    public selectedCompany: number;
    public companyList: Array<Company>
    private _deviceList: Array<Device> = [];
    private _container: Container = {
        street: undefined,
        streetDesc: undefined,
        neighbor: undefined,
        rootType: undefined,
    }

    public get model() {
        return this._container
    }
    public set model(v: Container) {
        this._container = v;
    }
    public _containerEnum:ContainerEnum;
    public get containerEnum(): typeof ContainerEnum {
        return ContainerEnum; 
      }
    constructor(
        @Inject(MAT_DIALOG_DATA) private data:any,
        private toasterService: ToasterService,
        private _dialog: MatDialog,
        private _coordinatesFromAddressService: CoordinatesFromAddressService,
        private _companyService: CompanyService,
        private _translateService:TranslateService
    ) {
        super();
    }


    public async ngOnInit() {
        try {
            this.companyId=parseInt(localStorage.getItem("CompanyID"))
            if (this.companyId == 1) {
                this.companyList = await this._companyService.getCompanies();
            }

        } catch (error) {
            console.warn(error);

        }
        this.model.latitude = this.data.lat
        this.model.longitude = this.data.lng
        this.getCoordinateFromAddress();
    }

    public async getCoordinateFromAddress(){
        var address = await this._coordinatesFromAddressService.getAddress(this.model.latitude,this.model.longitude)
        if(address.address.town){
            this.model.neighbor = address.address.town;
            this.model.streetDesc = address.address.town
        }
        if(address.address.suburb){
            this.model.street = address.address.suburb
            this.model.streetDesc += (' / '+ address.address.suburb)
        }
        if(address.address.road){
            this.model.street += ( (this.model.street?' / ':'') + address.address.road)
            this.model.streetDesc += (' / ' + address.address.road)

        }
    }

    public async save() {
        var toDate = new Date
        var full_date = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(),toDate.getHours(),toDate.getMinutes(),toDate.getSeconds(),toDate.getMilliseconds());
        var rn=Math.floor(Math.random()*1000000);
        var time = full_date.getTime();
        var deviceId = "0"+(time.toString()+rn.toString()).slice(5, 20);
        this.model.status = true;
        if (this.operation == "create") {
            this.model.deviceId = deviceId
            this.model.simulation=true;
        }
        if (this.form.invalid) {
            this.toasterService.toastWarning(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
            );
            return;
        }
        if(this.model.altitude<=this.model.deadZone){
            this.toasterService.toastWarning(
                this._translateService.instant("DEAD_ZONE_LESS_ALTITUDE")
            )
            return;
        }
        this.model.companyId = this.companyId == 1 ? this.selectedCompany : this.companyId;
        this.operation == "create" ? this.added.emit(this.model) : this.updated.emit(this.model);

    }


}
